module.exports = __webpack_public_path__ + "img/Breadcrumb.2d8f4bd7.png";